export enum BrowseWritePermission {
	DENIED = 0,
	ALL = 1,
	WITHOUT_DELETE = 2
}

export type BrowseAccessLevel = "none" | "read" | "write" | "full";
export const BROWSE_ACCESS_LEVELS: BrowseAccessLevel[] = ["none", "read", "write", "full"];

export type BrowseButton = "add" | "edit" | "duplicate" | "delete" | "info";
export const BROWSE_BUTTONS: BrowseButton[] = ["add", "edit", "duplicate", "delete", "info"];

export class BrowsePermissions {
	CanRead:boolean = true;
	CanWrite:BrowseWritePermission = BrowseWritePermission.ALL;
	CanMakeViews:boolean = true;
	BrowseHidden:boolean = false;
	HiddenButtons:BrowseButton[] = [];

	public constructor(data:any){
		if (!data) return;
		this.CanRead = data.CanRead;
		this.CanWrite = data.CanWrite;
		this.CanMakeViews = data.CanMakeViews;
		this.BrowseHidden = data.BrowseHidden;
		this.HiddenButtons = data.HiddenButtons || [];
	}

	getJSON(){
		return {
			CanRead: this.CanRead,
			CanWrite: this.CanWrite,
			CanMakeViews: this.CanMakeViews,
			BrowseHidden: this.BrowseHidden,
			HiddenButtons: this.HiddenButtons
		};
	}

	hasWritePermissions():boolean {
		return this.CanWrite != BrowseWritePermission.DENIED;
	}

	hasDeletePermissions():boolean {
		return this.CanWrite == BrowseWritePermission.ALL;
	}

	getAccessLevel():BrowseAccessLevel {
		if (this.CanWrite == BrowseWritePermission.ALL) return "full";
		if (this.CanWrite == BrowseWritePermission.WITHOUT_DELETE) return "write";
		return this.CanRead ? "read" : "none";
	}

	setAccessLevel(level:BrowseAccessLevel) {
		if (level == "none") {
			this.CanRead = false;
		} else if (level == "read" || this.getAccessLevel() == "none") {
			this.CanRead = true;
		}
		if (level == "full") {
			this.CanWrite = BrowseWritePermission.ALL;
		} else if (level == "write") {
			this.CanWrite = BrowseWritePermission.WITHOUT_DELETE;
		} else {
			this.CanWrite = BrowseWritePermission.DENIED;
		}
	}

	isButtonHidden(button:BrowseButton):boolean {
		return this.HiddenButtons.includes(button);
	}

	setButtonHidden(button:BrowseButton, hidden:boolean) {
		let i = this.HiddenButtons.indexOf(button);
		if (hidden && i == -1) {
			this.HiddenButtons.push(button);
		} else if (!hidden && i != -1) {
			this.HiddenButtons.splice(i, 1);
		}
	}
}
